export const fontStyles = {
  header: "DM Sans, sans-serif",
  headerBold: "bold",
  headerSize: "3rem",
  text: "Montserrat, sans-serif",
}